import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';

import { DirectivesModule } from '@shared/directives/directives.module';
import { ButtonModule } from '@shared/components/button/button.module';
import { SelectModule } from '@shared/components/form/select/select.module';
import { FormFieldCrudControlsModule } from '@shared/components/formly-custom-templates/form-field-crud-controls/form-field-crud-controls.module';

import { CustomFieldHealthAndSafetyResponsibilitiesComponent } from './custom-field-health-and-safety-responsibilities.component';
import { InputModule } from '../../form/input/input.module';
 

@NgModule({
  declarations: [CustomFieldHealthAndSafetyResponsibilitiesComponent],
  imports: [
    CommonModule,
    FormlyModule,
    FormsModule,
    ReactiveFormsModule,
    DirectivesModule,
    ButtonModule,
    SelectModule,
    InputModule,
    FormFieldCrudControlsModule
  ],
  exports: [CustomFieldHealthAndSafetyResponsibilitiesComponent]
})
export class CustomFieldHealthAndSafetyResponsibilitiesModule { }
